export default function($) {
  var galleryList = $('.js-spa-gallery-list'),
      gallerySlide = $('.js-spa-gallery-slide'),
      galleryThumb = $('.js-spa-gallery-thumb'),
      slidesLength = $('.js-spa-gallery-slide').length,
      arrowLeft = $('.js-spa-gallery-left'),
      arrowRight = $('.js-spa-gallery-right');

  galleryThumb.on( 'click', function() {
    var index = $(this).attr('data-img'),
        width = gallerySlide.first().width(),
        margin = parseInt(index) * parseInt(width);

    galleryList.css('margin-left', '-' + margin + 'px'  );

    gallerySlide.each(function() {
      if ($(this).attr('data-slide') == index) {
        $(this).addClass('active');
      } else {
        $(this).removeClass('active');
      }
    });

    galleryThumb.each(function() {
      if ($(this).attr('data-img') == index) {
        $(this).addClass('active opacity-100');
      } else {
        $(this).removeClass('active opacity-100');
      }
    });

  })

  /* Arrows behaviour */

  arrowLeft.on( 'click', function() {
    var currentIndex = $('.js-spa-gallery-slide.active').attr('data-slide'),
        width = gallerySlide.first().width(),
        margin = (parseInt(currentIndex) - 1) * parseInt(width);

    if( currentIndex > 0 ) {

      gallerySlide.each(function() {
        if ($(this).attr('data-slide') == parseInt(currentIndex) - 1) {
          $(this).addClass('active');
        } else {
          $(this).removeClass('active');
        }
      });

      galleryThumb.each(function() {
        if ($(this).attr('data-img') == parseInt(currentIndex) - 1) {
          $(this).addClass('active opacity-100');
        } else {
          $(this).removeClass('active opacity-100');
        }
      });

      galleryList.css('margin-left', '-' + margin + 'px'  );
    }
  })

  arrowRight.on( 'click', function() {
    var currentIndex = $('.js-spa-gallery-slide.active').attr('data-slide'),
        width = gallerySlide.first().width(),
        margin = (parseInt(currentIndex) + 1) * parseInt(width);

    if( currentIndex < (slidesLength - 1 ) ) {

      gallerySlide.each(function() {
        if ($(this).attr('data-slide') == parseInt(currentIndex) + 1) {
          $(this).addClass('active');
        } else {
          $(this).removeClass('active');
        }
      });

      galleryThumb.each(function() {
        if ($(this).attr('data-img') == parseInt(currentIndex) + 1) {
          $(this).addClass('active opacity-100');
        } else {
          $(this).removeClass('active opacity-100');
        }
      });

      galleryList.css('margin-left', '-' + margin + 'px'  );
    }
  })


  /* Swipe behaviour
   * See https://stackoverflow.com/a/43232508
   */
  if($('#spa-gallery-viewport').length > 0) {
    document.getElementById('spa-gallery-viewport').addEventListener('touchstart', handleTouchStart, false);
    document.getElementById('spa-gallery-viewport').addEventListener('touchmove', handleTouchMove, false);
  }

  var xDown = null,
      yDown = null;

  function getTouches(evt) {
    return evt.touches ||             // browser API
    evt.originalEvent.touches; // jQuery
  }

  function handleTouchStart(evt) {
    const firstTouch = getTouches(evt)[0];
    xDown = firstTouch.clientX;
    yDown = firstTouch.clientY;
  };

  function handleTouchMove(evt) {
    if ( ! xDown || ! yDown ) {
      return;
    }

    var xUp = evt.touches[0].clientX,
        yUp = evt.touches[0].clientY,
        currentSlideIndex = $('.js-spa-gallery-slide.active').attr('data-slide'),
        width = gallerySlide.first().width(),
        margin = 0;

    var xDiff = xDown - xUp,
        yDiff = yDown - yUp;

    if ( Math.abs( xDiff ) > Math.abs( yDiff ) ) {/*most significant*/
      if ( xDiff > 0 ) {
        /* left swipe */
        margin = (parseInt(currentSlideIndex) + 1) * parseInt(width);

        if( currentSlideIndex < (slidesLength - 1 ) ) {

          gallerySlide.each(function() {
            if ($(this).attr('data-slide') == parseInt(currentSlideIndex) + 1) {
              $(this).addClass('active');
            } else {
              $(this).removeClass('active');
            }
          });

          galleryThumb.each(function() {
            if ($(this).attr('data-img') == parseInt(currentSlideIndex) + 1) {
              $(this).addClass('active opacity-100');
            } else {
              $(this).removeClass('active opacity-100');
            }
          });

          galleryList.css('margin-left', '-' + margin + 'px'  );
        }

      } else {
        /* right swipe */
        margin = (parseInt(currentSlideIndex) - 1) * parseInt(width);

        if( currentSlideIndex > 0 ) {

          gallerySlide.each(function() {
            if ($(this).attr('data-slide') == parseInt(currentSlideIndex) - 1) {
              $(this).addClass('active');
            } else {
              $(this).removeClass('active');
            }
          });

          galleryThumb.each(function() {
            if ($(this).attr('data-img') == parseInt(currentSlideIndex) - 1) {
              $(this).addClass('active opacity-100');
            } else {
              $(this).removeClass('active opacity-100');
            }
          });

          galleryList.css('margin-left', '-' + margin + 'px'  );
        }
      }
    }

    /* reset values */
    xDown = null;
    yDown = null;
  };


  $(window).on('resize', function() {
    galleryList.css('margin-left', '0'  );
    gallerySlide.removeClass('active');
    $('.js-spa-gallery-slide:first-of-type').addClass('active');
    galleryThumb.removeClass('active opacity-100');
    $('.js-spa-gallery-thumb:first-of-type').addClass('active opacity-100');
  })

}
